// --------------------------------------------------------------------------
// #107 - Bird selector - variation with select boxes
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var contexts = options.context;

    function init() {

        $.each(contexts, function (index, context) {

            var $context = $(context);
            var $selectBox = $context.find('[data-binding="selector"]');
            var activeClass = 'active';

            $selectBox.on('change', function () {
                if ($(this).val() !== '') {
                    $context.parent().addClass(activeClass);
                } else {
                    $context.parent().removeClass(activeClass);
                }
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/bgbw/bird-frequency.js
// module id = 221
// module chunks = 0